var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"message-panel"}},[_c('div',{staticClass:"notice"}),_c('div',{staticClass:"message-list"}),_c('div',{staticClass:"message-sender"})])
}]

export { render, staticRenderFns }